/****************************************************
 * Module Name:  addInclusionModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import InclusionProxy from "../../utility/proxy/manager/inclusionProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddInclusionModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newinclusion: this.props.editOperation ? this.props.sourceData.name : "",
      newinclusionfullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",
      newwebref: this.props.editOperation ? this.props.sourceData.webref : "",

      showError: false,

      validateInclusionPresentSpinner: false,
      showValidationMessage: false,
      inclusionAvailable: true,

      inclusionValidationError: "",
      fullNameValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newinclusion,
      fullname: this.state.newinclusionfullname,
      description: this.state.newdescription,
      webref: this.state.newwebref,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateInclusionPresent = (inclusionEntered) => {
    if (!inclusionEntered || inclusionEntered.trim() === "") return;

    this.setState({
      validateInclusionPresentSpinner: true,
    });

    InclusionProxy.CheckInclusionAvailable(inclusionEntered, (response) => {
      //if we got response that means inclusion is present at backend
      if (response) {
        //InclusionName already present
        this.setState({
          validateInclusionPresentSpinner: false,
          showValidationMessage: true,
          inclusionAvailable: false,
        });
      } else {
        //InclusionName not available, so can be used
        this.setState({
          validateInclusionPresentSpinner: false,
          showValidationMessage: true,
          inclusionAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (
      this.props.editOperation &&
      this.state.newinclusionfullname.length === 0
    )
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.inclusionAvailable ||
        this.state.newinclusionfullname.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add inclusion validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit Inclusion"
                : "Add New Inclusion"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Inclusion Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Inclusion <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newinclusion}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Inclusion (required)"
                          placeholder="Enter Inclusion"
                          value={this.state.newinclusion}
                          autoFocus
                          onBlur={(e) =>
                            this.validateInclusionPresent(
                              this.state.newinclusion
                            )
                          }
                          onChange={(e) =>
                            this.setState({
                              newinclusion: e.target.value,
                              showValidationMessage: false,
                              inclusionValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Inclusion Cannot be Empty",
                            })
                          }
                          helperText={this.state.inclusionValidationError}
                          error={this.state.inclusionValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateInclusionPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.inclusionAvailable ? (
                        <font color="green">Inclusion available</font>
                      ) : (
                        <font color="red">Inclusion not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Inclusion Fullname <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Inclusion Fullname (required)"
                        placeholder="Enter Inclusion Fullname"
                        value={this.state.newinclusionfullname}
                        onChange={(e) =>
                          this.setState({
                            newinclusionfullname: e.target.value,
                            fullNameValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Inclusion Fullname Cannot be Empty",
                          })
                        }
                        helperText={this.state.fullNameValidationError}
                        error={this.state.fullNameValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Web Reference</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Web Reference"
                        placeholder="Enter Web Reference"
                        value={this.state.newwebref}
                        onChange={(e) =>
                          this.setState({ newwebref: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
